import React, { Component } from 'react';

import { Offcanvas, Row, Col, Card } from 'react-bootstrap';

import CommonButton from '../components/CommonButton';
import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';

/**
import CommonFile from '../components/CommonFile';
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
import CustomDatePicker from "../components/CommonDatePicker";
*/

import * as Actions from '../actions/ActionCenter';
import * as fn from '../../library/function';
import * as helper from '../../library/helper';

import SimpleBar from 'simplebar-react';

class InputMasterDataPosition extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date()
        };
    }

    handleDateChange = (date) => { this.setState({ selectedDate: date }); };

    prepareInputs = async () => {
        const { URL, Action, Inputs, onUpdateState } = this.props;
        const isUpdateMode = Action.Mode === 'update';

        let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);

        if(Action.Mode === 'new'){
            let field = 'seq';
            let result = await Actions.getMaxSequence(this.updateState, URL + '/get-max-sequence', {sequenceField: field});
            if(result.success){ updatedInputs[field].value = result.seq; }
        }

        onUpdateState('Inputs', updatedInputs);
    }

    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            await this.prepareInputs();
        }
    }

    render = () => {
        let props = this.props;

        let { onInputChange, onCloseAlert, onSubmit, onDiscardSubmit } = props;

        let { App, Action, Inputs, InputGroup , Operation } = props;

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;

        return (
                <Offcanvas 
                    show={show}
                    placement="end" 
                    style={{ '--bs-offcanvas-width': helper.getOffcanvasWidth() }}
                    scroll={true}
                    backdrop={Submit ? "static" : true}
                    onHide={(e) => props.onClose(e)}
                >
                    <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                        <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                    </Offcanvas.Header>

                    <Offcanvas.Body className="custom-offcanvas-body">
                        
                        <CommonAlert 
                            alert={Action.Alert} 
                            callback={(e) => onCloseAlert(e)}
                        />
                        
                        <SimpleBar id="inputs" className="simple-bar-input">

                            {/** 
                            <Card bg="light">
                                <Card.Body>
                            */}
                                    <Row>
                                        <Col md={12}>
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.name}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.seq}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.status}
                                                option={{source: 'options', section: 'status', item: 'default'}}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row>
                            {/** 
                                </Card.Body>
                            </Card>
                            */}

                        </SimpleBar>

                    </Offcanvas.Body>
                    
                    <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">
                        
                        <CommonLoadingBar isLoading={isLoading} />

                        <div className="d-flex justify-content-end mt-2">
                            <CommonButton 
                                task={mode} 
                                disabled={isLoading ? true : Submit ? false : true}
                                callback={async (e) =>{  
                                    await onSubmit(e);
                                    this.prepareInputs();
                                }} 
                            />

                            {Action.Mode === 'new' && (
                                <CommonButton 
                                    task="discard" 
                                    inlineClass="ms-1" 
                                    disabled={isLoading} 
                                    callback={(e) => onDiscardSubmit(false)} 
                                />
                            )}
                        </div>
                    </div>
                </Offcanvas>      
        )
    }
}

export default InputMasterDataPosition;